import { useState, useEffect } from 'react';

export type Countdown = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  expired: boolean;
  label: string;
};

type Parts = { d: number; h: number; m: number; s: number };

function pad(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

function buildLabel({ d, h, m, s }: Parts): string {
  const parts: string[] = [];
  if (d > 0) parts.push(`${pad(d)}d`);
  if (h > 0) parts.push(`${pad(h)}h`);
  if (m > 0) parts.push(`${pad(m)}m`);
  if (s > 0 || parts.length === 0) parts.push(`${pad(s)}s`);
  return parts.join(' ');
}

function calcCountdown(diff: number): Countdown {
  if (diff <= 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      expired: true,
      label: 'Expirado',
    };
  }
  const d = Math.floor(diff / 86_400_000);
  const h = Math.floor((diff % 86_400_000) / 3_600_000);
  const m = Math.floor((diff % 3_600_000) / 60_000);
  const s = Math.floor((diff % 60_000) / 1000);
  return {
    days: d,
    hours: h,
    minutes: m,
    seconds: s,
    expired: false,
    label: buildLabel({ d, h, m, s }),
  };
}

export function useCountdown(targetDate: string | undefined): Countdown | null {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!targetDate) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [targetDate]);

  if (!targetDate) return null;
  return calcCountdown(new Date(targetDate).getTime() - now);
}
